$(document).ready(function () {



    $(document).on('wpcf7beforesubmit', function (event) {
        // Code to execute while the form is sending
        $('.loader-estimate').addClass('active')
    });
    let formPresDeChezVous = 14944
    let formPresDeChezVousAnglais = 28296
    let formPresDeChezVousAllemand = 30852


    let formDevis = 14983
    let formDevisAnglais = 28471
    let formDevisAllemand = 30867


    let formBim = 15468


    let formContact = 22599
    let formContactAnglais = 28470
    let formContactAllemand = 30844

    $(document).on('wpcf7mailsent', function (event) {
        let seize_rest = seize_data.site_url + '/wp-json/cf7/v1'
        // Check if the sent form matches the form ID we are interested in
        var inputs = event.detail.inputs;
       

        switch (event.detail.contactFormId) {


            case formPresDeChezVous:
            case formPresDeChezVousAnglais:
            case formPresDeChezVousAllemand:

                var inputDemandeVal = inputs.find(input => input.name === 'concerne').value;
                var inputTypePoseVal = inputs.find(input => input.name === 'pose').value;
                var inputEmailVal = inputs.find(input => input.name === 'email').value;
                var inputDelaiVal = inputs.find(input => input.name === 'delai').value;
                var inputDemande = inputDemandeVal.includes('particulier') ? 'particulier' : 'professionnel';
                var inputTypePose = inputTypePoseVal === "J'ai mon poseur" ? "Poseur" : inputTypePoseVal === "Je pose moi-même" ? "moi_meme" : "cherche_artisan";
                var inputEmail = inputEmailVal
                var inputDelai = inputDelaiVal === "1 mois" ? "1_mois" : inputDelaiVal === "3 mois" ? "3_mois" : inputDelaiVal === "6 mois" ? "6_mois" : "indefini";
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    "event": "formulaire_contact_succes",
                    "form_demande_concerne": inputDemande,
                    "form_type_pose": inputTypePose,
                    "form_delai_projet": inputDelai,
                    "user_email": inputEmail
                });



                /**
                * 
                * Message de confirmation
                * 
                */

                $.ajax({
                    url: seize_rest + '/confirmationtemplate',
                    dataType: "json",
                    type: 'POST',
                    data: {
                        inputs: inputs,
                        form: 'presdechezvous',
                        // Add more data parameters as needed
                    },
                    success: function (response) {
                        // Save the JSON string in a cookie
                        $('.form-row').html(response.html);
                        $('.form-title__description').hide();
                        $('.form-title__title').hide();
                        setCookie('estimateProducts', [], 7);
                        $("html, body").animate({ scrollTop: 0 }, "slow");
                        $('.loader-estimate').removeClass('active')
                    }
                })


                break;
            case formDevis:
            case formDevisAnglais:
            case formDevisAllemand:

                var inputDemandeVal = inputs.find(input => input.name === 'concerne').value;
                var inputTypePoseVal = inputs.find(input => input.name === 'pose').value;
                var inputEmailVal = inputs.find(input => input.name === 'email').value;
                var inputDelaiVal = inputs.find(input => input.name === 'delai').value;
                var inputProduitVal = inputs.find(input => input.name === 'list-whishlist').value;

                var inputDemande = inputDemandeVal.includes('particulier') ? 'particulier' : 'professionnel';
                var inputTypePose = inputTypePoseVal === "J'ai mon poseur" ? "Poseur" : inputTypePoseVal === "Je pose moi-même" ? "moi_meme" : "cherche_artisan";
                var inputEmail = inputEmailVal
                var inputDelai = inputDelaiVal === "1 mois" ? "1_mois" : inputDelaiVal === "3 mois" ? "3_mois" : inputDelaiVal === "6 mois" ? "6_mois" : "indefini";

                var inputProductArray = JSON.parse(inputProduitVal);
                var numberOfObjects = inputProductArray.length;
                let products = [];
                inputProductArray.forEach(function (obj, index) {
                    products.push({ "item_name": obj.libelle });
                });


                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    "event": "formulaire_devis_succes",
                    "form_demande_concerne": inputDemande,
                    "form_type_pose": inputTypePose,
                    "form_delai_projet": inputDelai,
                    "user_email": inputEmail,
                    "product_count": numberOfObjects,
                    "products": products
                });

                /**
                 * 
                 * Message de confirmation
                 * 
                 */

                $.ajax({
                    url: seize_rest + '/confirmationtemplate',
                    dataType: "json",
                    type: 'POST',
                    data: {
                        inputs: inputs,
                        form: 'devis',
                        // Add more data parameters as needed
                    },
                    success: function (response) {
                        // Save the JSON string in a cookie
                        $('.form-row').html(response.html);
                        $('.form-title__description').hide();
                        $('.form-title__title').hide();
                        setCookie('estimateProducts', [], 7);
                        $("html, body").animate({ scrollTop: 0 }, "slow");
                        $('.loader-estimate').removeClass('active')
                    }
                })



                break;
            case formBim:

                var inputEmailVal = inputs.find(input => input.name === 'email').value;
                var inputEmail = inputEmailVal
                var bimProduct = $('.product-bim span').text()
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    "event": "formulaire_bim_succes",
                    "user_email": inputEmail,
                    "product_count": 1,
                    "products": [{ "item_name": bimProduct }]
                });
                $.ajax({
                    url: seize_rest + '/confirmationtemplate',
                    dataType: "json",
                    type: 'POST',
                    data: {
                        inputs: inputs,
                        form: 'bim',
                        // Add more data parameters as needed
                    },
                    success: function (response) {
                        // Save the JSON string in a cookie
                        $('.form-bim').html(response.html);
                        setCookie('BIM', [], 7);
                        $('.loader-estimate').removeClass('active')


                    }
                })

                break;
            case formContact:
            case formContactAnglais:
            case formContactAllemand:


                var inputDemandeVal = inputs.find(input => input.name === 'project-client-pro').value;
                var inputEmailVal = inputs.find(input => input.name === 'email').value;
                var inputDemande = inputDemandeVal.includes('particulier') ? 'particulier' : 'professionnel';
                var inputEmail = inputEmailVal
                var inputDelai = "indefini";
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    "event": "formulaire_contact_succes",
                    "form_demande_concerne": inputDemande,
                    "form_type_pose": '',
                    "form_delai_projet": inputDelai,
                    "user_email": inputEmail
                });


                /**
                    * 
                    * Message de confirmation
                    * 
                    */

                $.ajax({
                    url: seize_rest + '/confirmationtemplate',
                    dataType: "json",
                    type: 'POST',
                    data: {
                        inputs: inputs,
                        form: 'contact',
                        // Add more data parameters as needed
                    },
                    success: function (response) {
                        // Save the JSON string in a cookie
                        $('.form-row').html(response.html);
                        $('.form-title__description').hide();
                        $('.form-title__title').hide();
                        $("html, body").animate({ scrollTop: 0 }, "slow");
                        $('.loader-estimate').removeClass('active')
                    }
                })

                break;
            default:
                break;
        }
    });


    $(document).ajaxComplete(function (event, xhr, settings) {

        // Check if the AJAX request is the one you're interested in
        if (settings.data && typeof settings.data === 'string' && settings.data.includes("subscribe_form_submit")) {
            // Parse the JSON response
            var response = JSON.parse(xhr.responseText);
            // Check if the response status is "success"
            if (response.status && response.status === "success") {
                // Do what you need to do on success

                // Example: You can trigger a custom event or execute any code here

                var sentData = {
                    email: '',
                    listIDs: []
                };

                // Parse the data sent in the request
                settings.data.split('&').forEach(function (part) {
                    var item = part.split('=');
                    var key = item[0];
                    var value = decodeURIComponent(item[1]);

                    // Check for the email field
                    if (key === 'email') {
                        sentData.email = value;
                    }
                    // Check for listIDs[] field and accumulate values
                    else if (key.includes('listIDs')) {
                        sentData.listIDs.push(value);
                    }
                });

                var list
                if (sentData.listIDs[0] == "34") {
                    list = "particulier"
                } else {
                    list = "professionnel"
                }

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    "event": "formulaire_newsletter_succes",
                    "newsletter_type": list,
                    "user_email": sentData.email
                });

            }
        }


    });


    if (seize_data.user_mail) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "login",
            "user_mail": seize_data.user_mail
        });
    }

    $(document).on('click', '.bim-listing__marquage', function () {
        let bimName = $(this).attr('data-name')
        let bimMail = $("#bim-listing").attr('data-mail');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "formulaire_bim_succes",
            "user_email": bimMail,
            "product_count": 1,
            "products": [
                { "item_name": bimName },
            ]
        });
    })

    $(document).on('click', '.listing-product__single-icon', function () {
        let name = $(this).closest('.listing-product__single').attr('data-libelle')
        let ref = $(this).attr('data-ref')
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            "event": "add_to_wishlist",
            "position": "1",
            "ecommerce": {
                "currency": "EUR",
                "value": '0',
                "items": [
                    {
                        "item_id": ref,
                        "item_name": name,
                        "item_category": "parquet",
                        "item_brand": "",
                        "index": 1,
                        "price": 0,
                        "quantity": 1
                    }
                ]
            }
        });

    })
})

export function marquageTunnel(formData, titleStep, formCookie = null) {

    let formId = formData.get('formid')
    switch (formId) {
        case 'form-post-type':
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "tunnel_guide_step_01",
                "step_name": titleStep,
                "type_produit": formData.get('post_type')
            });
            break;
        case 'form-rooms':

            var roomsCount = 0;
            var roomNames = [];

            formData.forEach(function (value, key) {

                if (key === "rooms") {
                    roomsCount++;
                    roomNames.push(value);
                }
            });

            // Create a string with room names separated by "|"
            var roomNamesString = roomNames.join("|");

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "tunnel_guide_step_02",
                "step_name": titleStep,
                "type_piece": roomNamesString,
                "nbre_type_piece": roomsCount
            });


            break;

        case 'form-colors':
            var colors = []
            formData.forEach(function (value, key) {
                if (key !== "formid" && key !== "back") {
                    var trimmedValue = value.slice(0, -3);
                    if (!colors.includes(trimmedValue)) {
                        colors.push(trimmedValue);
                    }
                }
            })
            var colorsString = colors.join("|");

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "tunnel_guide_step_03",
                "step_name": titleStep,
                "type_coloris": colorsString
            });
            break;


        case 'form-format':
            var format = []
            formData.forEach(function (value, key) {
                if (key !== "formid" && key !== "back") {
                    var trimmedValue = value.slice(0, -3);
                    if (!format.includes(trimmedValue)) {
                        format.push(trimmedValue);
                    }
                }
            })
            var formatString = format.join("|");

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "tunnel_guide_step_04",
                "step_name": titleStep,
                "type_format": formatString
            });
            break;
        case 'form-width':
            var width = []
            formData.forEach(function (value, key) {
                if (key !== "formid" && key !== "back") {
                    var trimmedValue = value.slice(0, -3);
                    if (!width.includes(trimmedValue)) {
                        width.push(trimmedValue);
                    }
                }
            })
            var widthString = width.join("|");

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "tunnel_guide_step_05",
                "step_name": titleStep,
                "type_largeur": widthString
            });
            break;
        case 'form-aspect':
            var aspect = []
            formData.forEach(function (value, key) {
                if (key !== "formid" && key !== "back") {
                    var trimmedValue = value.slice(0, -3);
                    if (!aspect.includes(trimmedValue)) {
                        aspect.push(trimmedValue);
                    }
                }
            })
            var aspectString = aspect.join("|");

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "tunnel_guide_step_06",
                "step_name": titleStep,
                "type_aspect": aspectString
            });
            break;
        case 'form-money':
            var money = []
            formData.forEach(function (value, key) {
                if (key !== "formid" && key !== "back") {
                    var trimmedValue = value.slice(0, -3);
                    if (!money.includes(trimmedValue)) {
                        money.push(trimmedValue);
                    }
                }
            })
            var moneyString = money.join("|");

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "tunnel_guide_step_07",
                "step_name": titleStep,
                "type_aspect": moneyString
            });

            var rooms = [];
            var colors = [];
            var formats = [];
            var widths = [];
            var aspects = [];
            var money = [];
            var roomTypes = [];

            var roomsArray = JSON.parse(formCookie['rooms'])

            // Iterate through each entry in the array
            roomsArray.forEach(function (roomType) {
                roomType.list.forEach(function (room) {
                    // Add room to rooms array if it's not already present
                    if (!rooms.includes(room.room)) {
                        rooms.push(room.room);
                    }
                    if (!roomTypes.includes(roomType.roomType)) {
                        roomTypes.push(roomType.roomType);
                    }
                    // Extract unique values for colors, formats, widths, aspects, and money
                    if ((room.colors)) {
                        colors = colors.concat(room.colors.split(',').filter(function (color) {
                            return !colors.includes(color);
                        }));
                    }
                    if ((room.format)) {
                        formats = formats.concat(room.format.split(',').filter(function (format) {
                            return !formats.includes(format);
                        }));
                    }
                    if ((room.width)) {
                        widths = widths.concat(room.width.split(',').filter(function (width) {
                            return !widths.includes(width);
                        }));
                    }
                    if ((room.aspect)) {
                        aspects = aspects.concat(room.aspect.split(',').filter(function (aspect) {
                            return !aspects.includes(aspect);
                        }));
                    }
                    if ((room.money)) {
                        money = money.concat(room.money.split(',').filter(function (moneyItem) {
                            return !money.includes(moneyItem);
                        }));
                    }
                });
            });

            // Join the unique values into strings
            var colorsString = colors ? colors.join(',') : '';
            var formatsString = formats ? formats.join(',') : '';
            var widthsString = widths ? widths.join(',') : '';
            var aspectsString = aspects ? aspects.join(',') : '';
            var moneyString = money ? money.join(',') : '';
            var roomsTypeString = roomTypes ? roomTypes.join(',') : '';




            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "tunnel_guide_succes",
                "step_name": "Proposition produit(s) projet",
                "type_budget": moneyString,
                "type_aspect": aspectsString,
                "type_produit": formCookie['post-type'],
                "type_piece": roomsTypeString,
                "nbre_type_piece": rooms.length,
                "type_coloris": colorsString,
                "type_format": formatsString,
                "type_largeur": widthsString
            });

            break;
        default:
            break;
    }

}

function setCookie(name, value, days) {
    var expires = "";

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/; SameSite=Lax";

}


function getCookie(name) {
    // Split the document.cookie string by ';' to get all individual cookies
    let cookies = document.cookie.split(';');

    // Iterate over each cookie
    for (let i = 0; i < cookies.length; i++) {
        // Trim any leading whitespace
        let cookie = cookies[i].trim();

        // Check if the cookie starts with the name we're looking for
        if (cookie.indexOf(name + '=') == 0) {
            // Return the cookie value (the part after '=')
            return cookie.substring(name.length + 1);
        }
    }
    // Return null if the cookie was not found
    return null;
}
